import { authenticatedFetch } from './base'

export const fetchLanguages = (id) => {
	return authenticatedFetch(`/api/language`, {
		method: 'GET',
		headers: { 'content-type': 'application/json' }
	})
		.then(function(response) {
			if (response.status === 200) {
				return response.json()
			}
		})
		.then(function(circle) {
			return circle
		})
}
